module.exports = __webpack_public_path__ + "resources/img/js.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/js.png
// module id = 1107
// module chunks = 0